import {IS_BLOCKING_INFOCHANNEL,PATH_NAME_INFOCHANNEL} from '../infochannels/action';

export const isBlockingInfoChannelReducer = (previousState = false, { type, payload }) => {
    if (type === IS_BLOCKING_INFOCHANNEL) {
        return payload;
    }
    return previousState;
};

export const pathNameInfoChannelReducer = (previousState = '/infochannel', { type, payload }) => {
    if (type === PATH_NAME_INFOCHANNEL) {
        return payload;
    }
    return previousState;
};
